export const SIGNIN_CALLBACK = '/signin-callback';

const HOME = '/';
const INTERNAL_PATH = /^\/(?!\/)/;

export class RequestedPage {
  static home(): RequestedPage {
    return new RequestedPage(HOME);
  }

  static fromPath(path: unknown): RequestedPage {
    if (typeof path === 'string' && RequestedPage.#isReachable(path)) {
      return new RequestedPage(path);
    }

    return RequestedPage.home();
  }

  static #isReachable(path: string): boolean {
    return INTERNAL_PATH.test(path) && !path.startsWith(SIGNIN_CALLBACK);
  }

  private constructor(readonly path: string) {}
}
